export const availableInventoryTooltipLabel = $localize`:Config Strip|Inventory available tooltip label@@inventoryAvailableTooltip:We can supply`;
export const trueDemandInventoryTooltipLabel = $localize`:Config Strip|Inventory true demand tooltip label@@inventoryOutstandingDemandTooltip:Outstanding Demand`;
